interface SaveDeviceAndPassData {
  type?: any
  manufacturer?: any
  model?: any
  carrier?: any
  site?: any
  center?: any
  production_date?: string
  warranty_expiration_date?: string
  serviceStatus?: any
}

const setSaveDeviceAndPassData = (data: SaveDeviceAndPassData | null) => ({
  type: 'SET_SAVE_DEVICE_AND_PASS_DATA',
  payload: data,
})

export default setSaveDeviceAndPassData
